export default {
    'shoppingNote.title': 'ข้อควรทราบเกี่ยวกับการช็อปปิ้ง',
} as Record<string, string>;

